import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import MergeTagChip from "components/Editor/MergeTagWarning/MergeTagChip";

interface NoMergeTagsWarningDialogProps {
  open: boolean;
  handleClose: () => void;
  onProceed: () => void;
}

export default function NoMergeTagsWarningDialog({
  open,
  handleClose,
  onProceed,
}: NoMergeTagsWarningDialogProps) {
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>👋 Before you finish!</DialogTitle>
      <DialogContent>
        To save you time in the future, use{" "}
        <MergeTagChip mergeTag="{First Name}" /> and{" "}
        <MergeTagChip mergeTag="{Brand Name}" /> in your email templates, and we
        will automatically fill them in for you for every brand and contact you
        reach out to!
      </DialogContent>
      <DialogActions>
        <Button onClick={onProceed}>Save as is</Button>
        <Button variant="contained" onClick={handleClose}>
          Continue to edit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
